// extracted by mini-css-extract-plugin
export default {"form":"Form_form__f7JAR","title":"Form_title__yxzAE","sub_title":"Form_sub_title__FgjQV","form_wrapper":"Form_form_wrapper__kvPnf"};